import { useState, useEffect, useRef } from "react";
import { RequestError, useApi } from "../../services";
import { ErrorOnDialog, LoadingModal } from "..";
import { useBarragemContext, useUserContext } from "../../context";
import { Box, TextField } from "@mui/material";


export const ImpactosAmbientais = () => {
  const api = useApi();
  const { barragem } = useBarragemContext();
  const user = useUserContext();

  const timer = useRef<NodeJS.Timer>();
  const [error, setError] = useState<RequestError>();
  const [urlIframe, setUrlIframe] = useState('');
  const [urlInput, setUrlInput] = useState('');


  useEffect(() => {
    if (!barragem || "error" in barragem) return;

    api.barragem.getImpactosAmbientaisUrl(barragem.id).then((value) => {
      if ("error" in value) {
        setError(value);
        return;
      }
      setUrlIframe(value.urlImpactosAmbientais ?? "");
      setUrlInput(value.urlImpactosAmbientais ?? "");
    });
  }, [barragem]);

  const handleUpdate = (newUrl: string) => {
    setUrlInput(newUrl);

    if (!barragem || "error" in barragem) return;
    if (timer.current) clearTimeout(timer.current);

    timer.current = setTimeout(() => {
      api.barragem.updateImpactoAmbientaisUrl(barragem.id, newUrl).then((res) => {
        if ("error" in res) {
          setError(res);
        } else {
          setUrlIframe(urlInput);
        }
      });
    }, 100);
  };


  if (urlIframe === undefined) return <LoadingModal open={true} />;

  return (
    <>
      <ErrorOnDialog
        open={Boolean(error)}
        error={error?.error ?? ""}
        message={error?.message ?? ""}
        onClose={() => setError(undefined)}
      />

      <Box sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
      }}>
        <iframe
          title="BI"
          width="100%"
          height="99%"
          src={urlIframe}
          allowFullScreen={true}
        />

        {user && !("error" in user) && user.admin &&
          <>
            <div style={{ height: "1em" }} />
            <TextField fullWidth label="URL BI" variant="standard"
              value={urlInput}
              onChange={(ev) => handleUpdate(ev.target.value)}
            />
          </>
        }
      </Box>
    </>
  );
};